import axios from 'axios'
import Vue from 'vue'
let axiosAccess = axios.create({
    baseURL: 'https://apodaca.rciempaquesplegadizos.com:8180/',
    
    headers: {
        
        'Content-Type': 'application/json',
       
      },
  })


export async function fetchAll (context){
    try{
    let url = "access/operador/_getall"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    
    let values = new FormData()
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
   
    context.commit('setDatos',response.data.data)
  
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
   
}

export async function reporteOperadorDia (context,payload){
    try{
    let url = "access/reporte/_poroperador_dia"//la direccion de la api
    context.commit('setLoading',true,{root:true}) //lanzamos el loading
    context.commit('flushReporte')//se limpia el storage
    let values = new FormData()
    values.append('operador',payload.operador)
    values.append('dia',payload.dia)  
    values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
    let response = await axiosAccess({
        method: 'POST',
        url: url,
        data: values
    })
    context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function reporteOperadorSemana (context,payload){
    try{
        let url = "access/reporte/_poroperador_semana"//la direccion de la api
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        context.commit('flushReporte')//se limpia el storage
        let values = new FormData()
        values.append('operador',payload.operador)
        values.append('semana',payload.semana)  
        values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
        let response = await axiosAccess({
            method: 'POST',
            url: url,
            data: values
        })
        context.commit('setReporte',response.data.data)
        }catch(error){
            context.commit('setError', error)
        }
        finally{
            context.commit('setLoading',false,{root:true})
        }
}
export async function reporteOperadorMes(context,payload){
    try{
        let url = "access/reporte/_poroperador_mes"//la direccion de la api
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        context.commit('flushReporte')//se limpia el storage
        let values = new FormData()
        values.append('operador',payload.operador)
        values.append('mes',payload.mes)  
        values.append('anno',payload.anno)
        values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
        let response = await axiosAccess({
            method: 'POST',
            url: url,
            data: values
        })
        context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}
export async function reporteOperadorAnno(context,payload){
    try{
        let url = "access/reporte/_poroperador_anno"//la direccion de la api
        context.commit('setLoading',true,{root:true}) //lanzamos el loading
        context.commit('flushReporte')//se limpia el storage
        let values = new FormData()
        values.append('operador',payload.operador)
        values.append('anno',payload.anno)
        values.append('token','Rmk2c2pZa3o2bDExM0dCUWdib1I=')
        let response = await axiosAccess({
            method: 'POST',
            url: url,
            data: values
        })
        context.commit('setReporte',response.data.data)
    }catch(error){
        context.commit('setError', error)
    }
    finally{
        context.commit('setLoading',false,{root:true})
    }
}